module.exports = __webpack_public_path__ + "static/media/ic_term_insurance_fisdom.28576fd6.svg";